import './css/main.scss';

function initTiny () {
  // Transform textareas into style-editable fields
  tinymce.init({
    selector: '.style-enabled',
    branding: false,
    content_style: 'body {font-size: 14px;}',
    menubar: false,
    statusbar: false,
    theme: 'silver',
    forced_root_block: false,
    force_br_newlines: true,
    force_p_newlines: false,
    plugins: 'autoresize lists link paste code',
    paste_block_drop: false,
    toolbar: 'undo redo | paste as text | code | bold italic | link | alignleft aligncenter alignright | numlist' +
      ' bullist',
    setup: function (editor) {
      editor.on('change', function () {
        tinymce.triggerSave()
      })
    },
  })
}


function manageActionModal (url, modalType) {
  // Manage modal creation, behaviour and ajax call
  const actionItems = {
    'title': gettext('Forgot your password?'),
    'message': gettext('Enter your e-mail address below, an e-mail will be sent to you to reset your password'),
    'button': gettext('Send password reset e-mail'),
    'successSelector': '#password-reset-message'
  }
  const body = document.querySelector('body');
  const template = document.querySelector('#modal-template');
  const instance = template.content.cloneNode(true)
  instance.getElementById('modal-title').innerText = actionItems.title
  instance.getElementById('modal-message').innerText = actionItems.message
  instance.getElementById('modal-button-validate').innerText = actionItems.button
  instance.getElementById('form-email').setAttribute('action', url)

  body.appendChild(instance);

  $('#action-modal').on('shown.bs.modal', function (e) {
    $('#id_email').focus()
  })
  $('#action-modal').on('hidden.bs.modal', function (e) {
    $('#id_email').val('')
    $('#id_username').focus()
    document.querySelector('#action-modal').remove()
  })
  $('#modal-button-validate').on('click', function () {
    var $form = $('#form-email');
    let email_input = document.getElementById('id-email')
    let email = email_input.value
    // Check email address proper formatting
    if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
      // Send ajax password reset request
      $.ajax({
        type: 'POST',
        url: $form.attr('action'),
        data: $form.serialize(),
        success: function (data) {
          $('.ajax-message').hide()
          $(actionItems.successSelector).css('display', 'block')
        },
        complete: function () {
          $('#action-modal').modal('hide')
        },
      })
    } else {
      document.getElementById('invalid-email').classList.remove('hidden')
    }
  })
  $('#id-email').on("keypress", function (event) {
    if (event.keyCode == 13) {
      $('#modal-button-validate').click()
      event.preventDefault()
    }
  })
}

$(document).ready(function () {
  let style = document.querySelector('.style-enabled')
  if (style) {
    initTiny()
  }

  let modalRequests = document.querySelectorAll(".make-modal");
  for (let i = 0; i < modalRequests.length; i++) {
    modalRequests[i].onclick = function () {
      manageActionModal(this.dataset.action, this.dataset.modaltype)
    }
  }
})
